import axiosHelper from "../../../../axiosHelper";
import {
  APIUSEROLD,
  API_FAILURE,
  GET_ALL_SUPPLIER,
  GET_NEW_BLOCKED_SUPPLIER_EXPORT,
  GET_NEW_REQUEST_HISTORY_EXPORT,
} from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
//Havells
export function updateUserData(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.updateNewSupplierRequest, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // apiErrors(error)
        // callback(error);
      });
  };
}
export function getTypeEstablishment() {
  const request = axiosHelper.get(`${APIUSEROLD.getTypeOfEstablishment}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }

    });
}

export function getTyBuisness() {
  const request = axiosHelper.get(`${APIUSEROLD.getTypeOfBuisness}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }

    });
}
export function getUserByVendorUnblocking(id, vendorCode) {
  const request = axiosHelper.get(`${APIUSEROLD.getUserByUnblocking}?vendorRequirementRegistrationId=${id || 0}&vendorCode=${vendorCode}`);

  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getCityMasterServiceFilter() {
  const request = axiosHelper.get(`${APIUSEROLD.getCityMasterFilter}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getSupplierSpecializationService(selectedBusinessTypeId) {
  const request = axiosHelper.post(`${APIUSEROLD.getSupplierSpecialization}`, {
    businessTypeId: selectedBusinessTypeId,
  });
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getYearOfBuisnessService() {
  const request = axiosHelper.get(`${APIUSEROLD.getYearOfBuisness}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getRelationService() {
  const request = axiosHelper.get(`${APIUSEROLD.getRelationService}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getCurrencyList() {
  const request = axiosHelper.get(`${APIUSEROLD.getCurrencyListService}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}

export function getCurrencyScaleList(currencyId) {
  const request = axiosHelper.post(`${APIUSEROLD.getCurrencyListPostService}`, {
    currencyId,
  });
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}

export function getCountryService() {
  const request = axiosHelper.get(`${APIUSEROLD.getCountryService}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getStateSelection(countryId) {
  const request = axiosHelper.post(`${APIUSEROLD.getStateService}`, {
    countryId,
  });
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getDistrictSelection(stateId) {
  const request = axiosHelper.post(`${APIUSEROLD.getDistrictService}`, {
    stateId,
  });
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getCitySelection(districtId) {
  const request = axiosHelper.post(`${APIUSEROLD.getCityService}`, {
    districtId,
  });
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}
export function getServiceHowDidYouHearAbout() {
  const request = axiosHelper.get(`${APIUSEROLD.getServiceHowDidYouHear}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }
    });
}

export function addNewSupplierByHavells(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.addNewSupplierByHavells, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        } else {
          callback(error);
        }
       
      });
  };
}

export function supplierListing(filter, callback) {


  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getAllSupplierListing}`, {
      params: {
        RequestNo: filter?.floatingFilterData?.SupplierRepositoryRequestNo || filter?.btnextData?.SupplierRepositoryRequestNo,
        VendorCode: filter?.floatingFilterData?.VendorCode,
        page: filter.current_page,
        pageSize: filter.per_page,
        registrationType: filter.filter || filter?.FilterPotential || filter?.registrationType,
        SortBy: filter?.sort_column,
        SortOrder: filter?.sort_order,
        City: filter?.City || filter?.floatingFilterData?.CityName || filter?.btnextData?.CityName || null,
        SupplierType: filter?.SupplierType || 0,
        Name: filter?.supplierName || filter?.floatingFilterData?.SupplierName || filter?.btnextData?.SupplierName || null,
        SupplierSpecialization: filter?.supplierSpecialization || filter?.floatingFilterData?.SpecializationName || filter?.btnextData?.SpecializationName || null,
        EmailAddress: filter?.floatingFilterData?.EmailAddress || filter?.btnextData?.EmailAddress || null,
        ContactNo: filter?.floatingFilterData?.ContactNumber || filter?.btnextData?.ContactNumber || null,
        ApproverName: filter?.floatingFilterData?.Approver || filter?.btnextData?.Approver || null,
        ApplicationNo: filter?.floatingFilterData?.ApplicationNo || filter?.btnextData?.ApplicationNo || null,
        Country: filter?.Country || 0,
        SupplierCategory: filter?.floatingFilterData?.VendorCategory ? 0 : filter?.SupplierCategory || filter?.floatingFilterData?.VendorCategory || 0,
        CategoryName: filter?.floatingFilterData?.VendorCategory ? filter.floatingFilterData.VendorCategory : undefined,
        SupplierName: filter?.SupplierName || filter?.floatingFilterData?.SupplierName || filter?.btnextData?.SupplierName || null,
        TypeOfBusiness: filter?.TypeOfBusiness || 0,
        BusinessType: filter?.floatingFilterData?.TypeOfBusiness || filter?.btnextData?.TypeOfBusiness,
        PANNo: filter?.PanNo || null,
        BlockReason: filter?.floatingFilterData?.BlockReason || filter?.btnextData?.BlockReason,
        RequestFromDate:
          filter?.requestFromDate || filter?.btnextData?.requestFromDate,
        RequestToDate:
          filter?.requestToDate || filter?.btnextData?.requestToDate,
      },
    });

    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_ALL_SUPPLIER,
            payload: {
              data: response.status === 204 ? [] : response?.data?.Result,
              filter,
            },
          });
          callback(response, null);
        } else {
          callback(null, new Error("No data received from the server."));
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        } else {
          callback(null, error);
        }
       
      });
  };
}

export function AddNewSupplierRequest(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.addNewSupplierRequest, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        } 
        // apiErrors(error)
        // callback(error);
      });
  };
}

export function InviteNewSupplier(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.inviteNewSupplier, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        // apiErrors(err2or)
        if (error.response.status === 401) {
          apiErrors(error)
        } else{
          callback(error);
        }
       
      });
  };
}

export async function excelDownloadPotentialEmployerList(params) {
  try {
    const response = await axiosHelper.post(
      `${APIUSEROLD.exportPotentialEmployerList}`,
      {
        // EmployeeId: params.Employe22eId,
        RegistrationType: parseInt(params.RegistrationType),
        PANNumber: params.PANNumber || null,
        Name: params?.searchText || null,
        City: params?.City,
        Country: params?.Country || 0,
        SupplierName: params?.SupplierName,
        SupplierCategory: params?.SupplierCategory,
        TypeOfBusiness: params?.TypeOfBusiness || 0,
        SupplierSpecification: params?.supplierSpecialization,
        SupplierType: params?.SupplierType || 0,
      }
    );
    const fileUrl = response.data.Data[0];
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    if (error.response.status === 401) {
      apiErrors(error)
    }else{
      throw error;
    }
    
  }
}
export function getSupplierFormDetailForUpdate(id) {
  const request = axiosHelper.get(
    `${APIUSEROLD.getSupplierFormDetailForUpdate}/${id}`
  ); // Include the id in the URL
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        throw error;
      }
    });
}
export function fetchExportAllSupplier(params, callback) {



  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getPotentialEmployerExport}`,
      {
        params: {
          RegistrationType: parseInt(params.RegistrationType),
          PANNo: params.PanNo || null,
          Name: params?.SupplierName || params?.supplierName,
          RequestNo: params?.SupplierRepositoryRequestNo,
          ApplicationNo: params?.ApplicationNo,
          City: params?.City || params?.CityName || null,
          Country: params?.Country || 0,
          // SupplierName: params?.SupplierName || params?.supplierName||0,
          SupplierCategory: params?.SupplierCategory || 0,
          TypeOfBusiness: params?.TypeOfBusiness || 0,
          BusinessType: params?.TypeOfBusiness,
          SupplierSpecialization: params?.SpecializationName || params?.supplierSpecialization,
          SupplierType: params?.SupplierType || 0,
          // PANNo:params?.PanNo||0
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              params, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}
export function fetchBlockedSupplierExport(params, callback) {


  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getPotentialEmployerExport}`,
      {
        params: {
          RegistrationType: parseInt(params.RegistrationType),
          VendorCode: params?.VendorCode,
          BlockReason: params?.BlockReason,
          PANNo: params.PanNo || null,
          Name: params?.SupplierName || params?.supplierName || null,
          RequestNo: params?.SupplierRepositoryRequestNo || null,
          ApplicationNo: params?.ApplicationNo || null,
          City: params?.City || params?.CityName || null,
          CategoryName: params?.VendorCategory ? params.VendorCategory : undefined,
          Country: params?.Country || 0,
          SupplierCategory: params?.SupplierCategory || 0,
          TypeOfBusiness: params?.TypeOfBusiness || 0,
          BusinessType: params?.TypeOfBusiness || 0,
          SupplierSpecialization: params?.SpecializationName || params?.supplierSpecialization || null,
          SupplierType: params?.SupplierType || 0,
          RequestFromDate:
            params?.requestFromDate || params?.btnextData?.requestFromDate,
          RequestToDate:
            params?.requestToDate || params?.btnextData?.requestToDate,
        },
      }
    );

    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_BLOCKED_SUPPLIER_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,
              params,
            },
          });
          if (callback) callback(response, null);
        }
      })
      .catch((error) => {

        dispatch({ type: API_FAILURE });


        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          if (callback) callback(null, error);
        }
      
      });
  };
}
